// extracted by mini-css-extract-plugin
export default {"info":"_2vjH","infoWrapper":"_1XQL","section":"_8JLl"};